import React from "react"
import { connect } from "react-redux"

import { push } from "connected-react-router"
import CoolPage from "../components/CoolPage"

import "./HotelMenuIndex.less"

/* eslint-disable comma-spacing */
const texts = {
  pageTitle: { ch: "我们的菜单", es: "Nuestra carta" },
  header: { ch: "了解我们的菜单", es: "Explora la carta" },
  sections: [
    { ch: "前菜", es: "Entrantes", img: "/static/img/nh/menu/section1_entrantes.jpg", key: "Entrantes"},
    { ch: "主菜", es: "Primeros" , img: "/static/img/nh/menu/section2_primeros.jpg", key: "Primeros" },
    { ch: "鱼", es: "Pescados" , img: "/static/img/nh/menu/section3_pescados.jpg", key: "Pescados" },
    { ch: "肉", es: "Carnes"   , img: "/static/img/nh/menu/section4_carnes.jpg", key: "Carnes" },
    { ch: "甜点", es: "Postres"  , img: "/static/img/nh/menu/section5_postres.jpg", key: "Postres" },
  ]
}
const lang = "ch"
/* eslint-enable comma-spacing */

/* eslint-disable react/prefer-stateless-function */
class Tepa2 extends React.PureComponent {
  render() {
    return (
      <CoolPage
        containerProps={{ className: "tepa" }}
        title={texts.pageTitle[lang]}
        barColor={[255, 255, 255]}
        className="tepaPage tepaMenuIndex"
        fixedBar
      >
        <h1>{texts.header[lang]}</h1>
        <div>
          {
            texts.sections.map(row => (
              <div 
                key={row.key} 
                className="section" 
                style={{ backgroundImage: `url(${row.img})` }}
                onClick={() => this.props.gotoSection(row.key)}
              >
                <div>
                  {row[lang]}
                </div>
              </div>
            ))
          }
        </div>
      </CoolPage>
    )
  }
}

const mapStateToProps = (_state, _ownProps) => ({ })

const mapDispatchToProps = dispatch => {
  const goto = url => dispatch(push(url))
  return {
    goto,
    gotoSection: key => goto(`/catalogo/tepa/menu/${key}`)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tepa2)



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/HotelMenuIndex.jsx